import { Markup } from 'interweave';
import React from 'react'
import { BASE_URL } from '../../config';
import videoImage from '../../images/video-img.jpg';
import youLogo from '../../images/youtube-icon.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useHistory } from 'react-router-dom';
function Course({ data, openModal, res }) {
  let navigate = useHistory();

  return (
    data?.length > 0 && <section className="coursecontainer">
      <div className="container">
        <div className="row">

          <div className="col-12">
            <div className="videoimg">

              {/* <img className="lazy" src={videoImage} width="1296" height="491" alt=""/> */}
              <LazyLoadImage
              class="lazy"
                alt={""}
                height={491}
                src={videoImage}
                width={1296} />
              <div className="videoovarlay">
                <a className="playbtn" id="play-video" style={{ height: "50px", backgroundImage: `${youLogo}` }} data-fancybox="course-video" href="" data-preload="true" data-width="100%" data-height="100%"><img onClick={openModal} className="lazy" src={youLogo} alt="" /></a>
              </div>

            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12 wow fadeInLeft">
            <div className="courselt">
              <h2>Course</h2>
              <Markup content={data[0]?.description} />
              <div className="pb-0 pb-lg-3">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                    <div className="cimg">
                      {/* <img className="lazy" src={`${BASE_URL}/${data[0]?.course_banner}`} width="251" height="230" alt=""/> */}
                      <LazyLoadImage
                      class="lazy"
                        alt={"Payment"}
                        height={230}
                        src={`${BASE_URL}/${data[0]?.course_banner}`} // use normal <img> attributes as props
                        width={251}
                      />
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                    {data[0]?.course_banner_2&&<div className="cimg">
                      {/* <img className="lazy" src={`${BASE_URL}/${data[0]?.course_banner_2}`} width="251" height="230" alt=""/> */}
                      <LazyLoadImage
                      class="lazy"
                        alt={"Payment"}
                        height={230}
                        src={`${BASE_URL}/${data[0]?.course_banner_2}`}
                        width={251}
                      />
                    </div>}
                  </div>
                </div>
              </div>
              <a className="default-btn" href="/course" onClick={(e) => { e.preventDefault(); navigate.push("/course") }}><span>Read More</span><i className="icon icon-long-arrow-right"></i></a>
            </div>
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 wow fadeInRight">

            <Markup content={res?.page_content} />
          </div>

        </div>
      </div>

    </section>
  )
}

export default Course